/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Meta_TitleInputs */

const es_chat_meta_title = /** @type {(inputs: Chat_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Chat`)
};

const en_chat_meta_title = /** @type {(inputs: Chat_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Chat`)
};

/**
* | output |
* | --- |
* | "Nexata \| Chat" |
*
* @param {Chat_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_meta_title = /** @type {((inputs?: Chat_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_meta_title(inputs)
	return en_chat_meta_title(inputs)
});
export { chat_meta_title as "chat.meta.title" }